import { ApiMethod } from '@wajeez-web/stores/base';
import {
  Server,
  identityClient,
  paymentClient,
} from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';
import {
  thunkErrorHandler,
  thunkResponseCheckerSdk,
} from '@wajeez-web/core/utils';

export const getUserById: ApiMethod<
  string,
  Server.UserDetailsOutput,
  any
> = async (userId, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Account_Client(undefined, identityClient);
    const response = await client.account_userId_get_V1(userId);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const deleteUserById: ApiMethod<string, void, any> = async (
  id,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Account_Client(undefined, identityClient);
    const response = await client.account_userId_delete_V1(id);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getPolicyById', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const blockUser: ApiMethod<string, void, any> = async (
  id,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Account_Client(undefined, identityClient);
    const response = await client.account_block_post_V1(id);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const setUserEmail: ApiMethod<
  Server.SetUserEmailInput,
  void,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Account_Client(undefined, identityClient);
    const response = await client.account_setEmail_post_V1(variables);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const setUserPassword: ApiMethod<
  Server.SetUserPasswordInput,
  void,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Account_Client(undefined, identityClient);
    const response = await client.account_setPassword_post_V1(variables);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const unblockUser: ApiMethod<string, void, any> = async (
  id,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Account_Client(undefined, identityClient);
    const response = await client.account_unblock_post_V1(id);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
    throw error;
  }
};

export const getUsersByEmail: ApiMethod<
  string,
  Server.UserDetailsOutput[],
  any
> = async (email, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Account_Client(undefined, identityClient);
    const response = await client.admin_Account_searchByEmail_get_V1(
      email,
      1,
      100
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const updateUserName: ApiMethod<
  Server.UpdateUserNameInput,
  void,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Account_Client(undefined, identityClient);
    const response = await client.admin_Account_updateName_put_V1(variables);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const updateUserGender: ApiMethod<
  Server.UpdateUserGenderInput,
  void,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Account_Client(undefined, identityClient);
    const response = await client.admin_Account_updateGender_put_V1(variables);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getUserGifts: ApiMethod<
  string,
  Server.CustomerGiftDashboardOutput[],
  any
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Gifts_Client(undefined, paymentClient);
    const response = await client.admin_Gifts_bought_get_V1(id);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const createUserGift: ApiMethod<
  Server.CreateCustomerGiftInput,
  Server.CustomerGiftDashboardOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Gifts_Client(undefined, paymentClient);
    const response = await client.admin_Gifts_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const consumeUserGift: ApiMethod<
  Server.ConsumeCustomerGiftInput,
  Server.CustomerGiftDashboardOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_Gifts_Client(undefined, paymentClient);

      const response = await client.admin_Gifts_consume_post_V1(data);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getSubsicriptionHistory: ApiMethod<
  string,
  Server.SubscriptionHistoryOutput[],
  any
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Products_Client(undefined, paymentClient);
    const response = await client.admin_Products_subscriptionHistory_get_V1(id);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const addCustomerProduct: ApiMethod<
  Server.AddCustomerProductInput,
  void,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Products_Client(undefined, paymentClient);
    const response = await client.products_addCustomerProduct_post_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const expireCustomerProduct: ApiMethod<
  Server.ExpireCustomerProductInput,
  void,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Products_Client(undefined, paymentClient);
    const response = await client.products_expireCustomerProduct_post_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
export const getProductByPurchaseSourceAndProductType: ApiMethod<
  {
    PurchaseSource?: Server.PurchaseSource;
    ProductType?: Server.ProductType;
  },
  Server.ProductOutput[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Products_Client(undefined, paymentClient);
    const response = await client.admin_Products_customerCareProducts_get_V1(
      undefined,
      data.PurchaseSource,
      data.ProductType
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getUserPoints: ApiMethod<string, number, any> = async (
  id,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Points_Client(undefined, identityClient);
    const response = await client.admin_Points_get_V1(id);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const addPointsToUser: ApiMethod<
  Server.AddPointsInput,
  void,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Points_Client(undefined, identityClient);
    const response = await client.admin_Points_post_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getUserPlans: ApiMethod<
  string,
  Server.CustomerPlanOutput[],
  any
> = async (customerId, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Plans_Client(undefined, paymentClient);
    const response = await client.admin_Plans_customer_get_V1(
      undefined,
      customerId
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('createNewPolicy', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const searchUsersByFilter: ApiMethod<
  string,
  Server.UserDetailsOutput[],
  void
> = async (searchKey, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_Account_Client(
        undefined,
        identityClient
      );

      const response = await client.admin_Account_searchUsersByFilter_get_V1(
        searchKey,
        1,
        100
      );

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getFcmTokenByUserId: ApiMethod<
  string,
  Server.GetUserFcmTokenByUserIdOutput,
  void
> = async (userId, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_Account_Client(
          undefined,
          identityClient
        );

        return client.account_userFcmToken_get_V1(userId);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};
